import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { modalProps, modalEmits } from './modal';
import { UPDATE_MODEL_VALUE } from '../../constants';
import { UiIconClose, UiIconRefresh, UiIconCheck } from '../../icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  props: modalProps,
  emits: modalEmits,
  setup(__props, { emit: emits }) {

const props = __props




const uiModalRef = ref<HTMLElement>();
const isVisible = ref<boolean>(false);
const animationClass = ref<string>('');

watch(() => props.modelValue, (value) => {
    if (value) {
        isVisible.value = true;
        animationClass.value = 'ui-modal--entering';
    } else {
        animationClass.value = 'ui-modal--leaving';
        uiModalRef.value?.addEventListener('animationend', () => {
            isVisible.value = false;
            animationClass.value = '';
        }, { once: true });
    }
}, { immediate: true });

const handleCloseModal = (): void => {
    emits(UPDATE_MODEL_VALUE, false);
    emits('close', false);
};

const handleCancelDialog = (): void => {
    emits('cancel', false);
    handleCloseModal();
};

const handleApproveDialog = (): void => {
    emits('approve', false);
};

return { __sfc: true,props, emits, uiModalRef, isVisible, animationClass, handleCloseModal, handleCancelDialog, handleApproveDialog, UiIconClose, UiIconRefresh, UiIconCheck }
}

})